/* import React from 'react';

export default function ReplyWidget({ title }) {
  return (
    <>
      <h3 className="cs_semibold cs_fs_24 mb-0">{title}</h3>
      <div className="cs_height_12" />
      <p className="cs_fs_18">
        Your email address will not be published. Required fields are marked *
      </p>
      <div className="cs_height_7" />
      <form action="#">
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Comment*
        </label>
        <textarea
          cols={30}
          rows={8}
          className="cs_form_field_2"
          defaultValue={''}
        />
        <div className="cs_height_20" />
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Your Name*
        </label>
        <input type="text" className="cs_form_field_2" />
        <div className="cs_height_20" />
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Your Email*
        </label>
        <input type="email" className="cs_form_field_2" />
        <div className="cs_height_30" />
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            defaultValue=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            Save my name and email in this browser for the next time I comment.
          </label>
        </div>
        <div className="cs_height_60" />
        <button className="cs_btn cs_style_1">
          <span>Submit</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </button>
      </form>
    </>
  );
}
 */
import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

export default function ReplyWidget({ title, postId }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !comment) {
      alert('All fields are required.');
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, `blogs/${postId}/comments`), {
        name,
        email,
        message: comment,
        timestamp: serverTimestamp(),
      });

      alert('Comment submitted successfully!');
      setName('');
      setEmail('');
      setComment('');
    } catch (err) {
      console.error('Error submitting comment:', err);
      alert('Error submitting comment. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h3 className="cs_semibold cs_fs_24 mb-0">{title}</h3>
      <div className="cs_height_12" />
      <p className="cs_fs_18">
        Your email address will not be published. Required fields are marked *
      </p>
      <div className="cs_height_7" />
      <form onSubmit={handleSubmit}>
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Comment*
        </label>
        <textarea
          rows={6}
          className="cs_form_field_2"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          required
        />
        <div className="cs_height_20" />
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Your Name*
        </label>
        <input
          type="text"
          className="cs_form_field_2"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <div className="cs_height_20" />
        <label className="cs_input_label cs_heading_color cs_fs_18 cs_medium">
          Your Email*
        </label>
        <input
          type="email"
          className="cs_form_field_2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <div className="cs_height_30" />
        <button
          type="submit"
          className="cs_btn cs_style_1"
          disabled={loading}
        >
          <span>{loading ? 'Submitting...' : 'Submit'}</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </button>
      </form>
    </>
  );
}
